import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import {
    createStyles,
    Progress,
    Text,
    ScrollArea,
    Paper
} from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';

import { SubscribersFilter } from '../components/SubscribersFilter';
import  SubscribersItem  from '../components/SubscribersItem';


import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    alertFilter: {
        position: 'absolute',
        left: '50px',
        //width: '30%',
        //margin: '0 auto'
    }
}));


//this needs params
const SubscribersPage = () => {
    const { classes, theme } = useStyles();
    const { height, width } = useViewportSize();

    
    //will be a map to items in redux based on new or read
    const alertItems = null;
    
    return (
        <>
            {/*
            <MobileSimpleHeader 
                avatar={pagani}
                drawSubSectMenu={false}
            />
            * /}
            {/*have a switch case for assignment of the sub menu*/}
            <br/>
            <SubscribersFilter/>
            <br/>
            <br/>
            <Paper shadow="xs" p="md">
                <ScrollArea
                    type="never"
                    h={height * 0.65}
                >
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <br/>
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <br/>
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <br/>
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                    <SubscribersItem
                        avatar={pagani}
                        username={"a username"}
                        status={"active"}
                    />
                </ScrollArea>
            </Paper>
            <FooterSimple />
        </>
    )

}

export default SubscribersPage
